import { useQuery } from '@tanstack/react-query';
import otrosApiService from '../../../../services/http/otrosApiService';
import alumnosApiService from '../../../../services/http/alumnosApiService';

const THIRTY_MINUTES = 30 * 60 * 1000;
const ONE_HOUR = 60 * 60 * 1000;

export const useHeadquarterOptions = () =>
  useQuery({
    queryKey: ['dropdown', 'empresas'],
    queryFn: () => otrosApiService.consultaEmpresas({ headquarter: '1' }),
    staleTime: THIRTY_MINUTES,
    gcTime: ONE_HOUR,
  });

export const useFormationCenterOptions = () =>
  useQuery({
    queryKey: ['dropdown', 'centrosFormacion'],
    queryFn: async () => {
      const data = await alumnosApiService.cargarCentrosFormacion({
        empresaId: 'CEDESCA',
      });
      data.unshift({ Id: '', Nombre: 'Todos' });
      return data.map((opcion) => ({
        value: opcion.Id,
        label: opcion.Nombre,
      }));
    },
    staleTime: THIRTY_MINUTES,
    gcTime: ONE_HOUR,
  });

export const useSearchFilterOptions = () =>
  useQuery({
    queryKey: ['dropdown', 'opcionesBuscarAlumno'],
    queryFn: () =>
      alumnosApiService.cargarOpcionesBuscarAlumno({ headquarter: '1' }),
    staleTime: THIRTY_MINUTES,
    gcTime: ONE_HOUR,
  });
